angular.module("CarsSaraBo").directive("alertEmailComponent", function () {
    return {
        restrict: 'E',
        controller: ["$routeParams", "$q", "$location", "$http", "AlertEmailService", "PointOfSaleService", "NotificationService", "LoadingWheelService", "SessionService", "ModalService", "EmailValidatorService", AlertEmailController],
        controllerAs: "ctrl",
        templateUrl: 'templates/alert-emails/alert-email.component.html',
        scope: {} // isolated scope
    };
});

function AlertEmailController($routeParams, $q, $location, $http, alertEmailService, pointOfSaleService, notificationService, loadingWheelService, sessionService, modalService, emailValidatorService) {
    var vm = this;
    
    function initialize() {
        loadingWheelService.show();
        vm.validations = {};
        vm.alertEmail = {
            types: [
                "RESERVE",
                "CANCELLATION",
                "RESERVE_MODIFICATION",
                "FLIGHT_MODIFICATION"
            ],
            pointOfSaleOids: [],
            language: "ES", // USE SESSION LANGUAGE!
            active: true
        };
        vm.companyOid = $routeParams.companyOid;
        $q.all([
            pointOfSaleService.resource.query({companyOid: vm.companyOid}).$promise,

            $http.get("../rest/data/alertType"),
            $http.get("../rest/data/language")
        ]).then(function (response) {
            vm.validations.pointsOfSale = true;
            vm.pointsOfSale = response[0];
            vm.alertTypes = response[1].data;
            vm.languages = response[2].data;
            loadingWheelService.hide();

            // Now load the alertEmail if ID has been provided...
            if ($routeParams.oid != 'new') {
                alertEmailService.get({
                    oid: $routeParams.oid,
                    companyOid: vm.companyOid
                }, function (response) {
                    vm.alertEmail = response;
                });
            }

        });
    }

    vm.isLanguageSelected = function (language) {
        return vm.alertEmail.language == language;
    };

    vm.toggleLanguage = function (language) {
        vm.alertEmail.language = language;
    };

    vm.isAlertTypeSelected = function (alertType) {
        return vm.alertEmail.types.indexOf(alertType) >= 0;
    };

    vm.toggleAlertType = function (alertType) {
        var options = vm.alertEmail.types;
        var idx = options.indexOf(alertType);

        if (idx >= 0) {
            options.splice(idx, 1);
        } else {
            options.push(alertType);
        }
    };

    vm.isPointOfSaleSelected = function (pointOfSale) {
        return vm.alertEmail.pointOfSaleOids.indexOf(pointOfSale.oid) >= 0;
    };

    vm.togglePointOfSale = function (pointOfSale) {
        var options = vm.alertEmail.pointOfSaleOids;
        var idx = options.indexOf(pointOfSale.oid);

        if (idx >= 0) {
            options.splice(idx, 1);
        } else {
            options.push(pointOfSale.oid);
        }
    };

    vm.updateValidation = function (field) {
        if (vm.errorField != undefined && vm.errorField[field]) {
            vm.errorField[field] = null;
        }
    };

    function isValid(errorList) {
        var isValid = true;
        if (!(emailValidatorService.validate(vm.alertEmail.email))) {
            vm.errorField['alertEmail'] = "input-error";
            errorList.push("common.form.validation.UNCOMPLETE_REQUIRED_FIELD");
            isValid = false;
        }
        if (!(vm.alertEmail.pointOfSaleOids.length > 0)) {
            vm.errorField['checkboxPointOfSale'] = "input-error";
            errorList.push("alertEmail.ERROR_POS_REQUIRED");
            isValid = false;
        }
        if (!(vm.alertEmail.types.length > 0)) {
            vm.errorField['checkboxTypes'] = "input-error";
            errorList.push("alertEmail.ERROR_TYPE_REQUIRED");
            isValid = false;
        }
        return isValid;
    }

    vm.save = function () {
        var deferred = $q.defer();
        vm.errorField = {};
      
        var errorList = [];

        if (isValid(errorList) && vm.alertForm.$valid) {
            if ($routeParams.oid == 'new') {
                alertEmailService.save({companyOid: vm.companyOid}, vm.alertEmail, function (response) {
                    notificationService.notifyInfoByCode("alertEmail.SAVE_SUCCESSFULL");
                    deferred.resolve();
                    goBack();
                }, function (error) {
                    deferred.reject();
                });
            } else {
                alertEmailService.update({
                    oid: $routeParams.oid,
                    companyOid: vm.companyOid
                }, vm.alertEmail, function (response) {
                    notificationService.notifyInfoByCode("alertEmail.SAVE_SUCCESSFULL");
                    deferred.resolve();
                    goBack();
                }, function (error) {
                    console.log(error);
                    deferred.reject();
                });
            }
        } else {
            deferred.reject();
            for (i in vm.alertForm.$error.required) {
                vm.errorField[vm.alertForm.$error.required[i].$name] = "input-error";
            }
            notificationService.notifyFrontErrorDetailByCodes(errorList);
        }
        return deferred.promise;
    };

    function goBack() {
        $location.path("/company/" + vm.companyOid + "/alertEmail");
    }

    vm.cancel = function () {
        modalService.show("CANCEL_ALERT_TITLE", "CANCEL_ALERT_DESCRIPTION", goBack);
    };

    vm.checkAll = function () {
        vm.alertEmail.pointOfSaleOids = [];
        var select = this.selectedAll;
        if (select) {
            angular.forEach(vm.pointsOfSale, function (item) {
                vm.togglePointOfSale(item);
            });
        }
    };

    initialize();
}


//////////////////
// WEBPACK FOOTER
// ./public/app/alert-emails/alert-email.component.js
// module id = 933
// module chunks = 3